<div class="user-list mr-5" *ngIf="pageUserService.usersOnCurrentPage">
  <span *ngFor="let user of pageUserService.usersOnCurrentPage">
    <span  class="badge rounded-pill bg-white user-page-list-border m-1 p-0"
    [ngStyle]="{'border-color': user.backgroundColor}" >
      <span class="badge rounded-pill text-white font-weight-normal m-0 p-2 user-page-list-text user-page-list-border"
      [ngStyle]="{'background-color': user.backgroundColor}" (mouseenter)="showName(user)"  (mouseleave)="hideName(user)">
        <span *ngIf="!user.showFullName">
            {{ user.initials}}
        </span>
        <span *ngIf="user.showFullName">{{ user.userName }}</span>
      </span>
    </span>
  </span>
</div>


// WEBPACK FOOTER //
// ./src/app/core/components/header/page-user-list/page-user-list.component.html